/* eslint-disable */
import React from 'react';

import Style from './title_style.module.css';

export const Title = (props) => {
  const { title, style } = props;
  return (
    <div className={Style.title} style={style}>
      {title}
    </div>
  );
};

export const PopupTitle = (props) => {
  const { title } = props;
  return <div className={Style.popuptitle}> {title} </div>;
};
